import $ from "jquery";
import { u_ } from "@pressmedia/webappbase";

export default {
	execModeValues: {
		confirm: "validate",
		exec: "exec",
		file: "upload"
	},
	
	/**
	* aSubmitへのブリッジ関数（aRequestConfirm, aRequestExec）
	* @param {String} execModeValue: "execMode"のリクエストパラメータの値
	* @param {Function | Object} opt: 成功コールバック or オプション項目（内容はaSubmitを参照）
	*/
	async aRequest(execModeValue, opt) {
		u_.isFunction(opt) && (opt = {
			success: opt
		});
		
		u_.isObject(opt) || (opt = {});
				
		// 引数をデフォルト値とマージ
		opt = {
			methodName: "aRequest",
			allSheets: false,	// trueの場合、全シートのデータを送信する
			type: "POST",
			begin() {},
			complete() {},
			...opt
		};
		
		const currentCbs = {};
		
		// 元々のbeginコールバックを退避
		currentCbs.begin = opt.begin;
		
		// 新たなbeginコールバックを登録
		opt.begin = function begin($fm) {
			const activeSheet = this.getActiveSheet();
			if(this.getSheet().length) {
				// アクティブなシートの情報を挿入
				$("<input/>").addClass("_tmp-inp").attr({
					type: "hidden",
					name: "sheet"
				}).val(activeSheet ? activeSheet.name : "").appendTo($fm);
			}
			
			if(this.enableAddExecModeParam) {
				// execModeを挿入
				$("<input/>").addClass("_tmp-inp").attr({
					type: "hidden",
					name: this.execModeParamName
				}).val(execModeValue).appendTo($fm);
			}
			
			if( !opt.allSheets && $fm.hasClass("is-clone") ) {
				// アクティブでは無いシートのデータは送信しない
				$fm.children(`.vuw-sheet:not(.${this.activeSheetClassName})`).remove();
			}
			
			// 元々のbeginコールバックを実行
			return currentCbs.begin.call(this, $fm);
		};
		
		// 元々のcompleteコールバックを退避
		currentCbs.complete = opt.complete;
		
		// 新たなcompleteコールバックを登録
		opt.complete = function complete($fm) {
			if( !$fm.hasClass("is-clone") ) {
				// cloneでは無い場合、beginで挿入した入力部品を削除
				$fm.children("._tmp-inp").remove();
			}
			
			// 元々のcompleteコールバックを実行
			return currentCbs.complete.call(this, $fm);
		};
		
		return this.aSubmit(opt);
	},
	
	/**
	* ajax サーバーへ入力データのバリデーションをリクエスト
	* @param {Function | Object} opt: 成功コールバック or オプション項目（内容はaSubmitを参照）
	*/
	aRequestConfirm(opt) {
		u_.isFunction(opt) && (opt = {
			success: opt
		});
		
		u_.isObject(opt) || (opt = {});
		opt = { methodName: "aRequestConfirm", ...opt };
		
		return this.aRequest(this.execModeValues.confirm, opt);
	},
	
	/**
	* ajax サーバーへ入力データの登録・更新をリクエスト
	* @param {Function | Object} opt: 成功コールバック or オプション項目（内容はaSubmitを参照）
	*/
	aRequestExec(opt) {
		u_.isFunction(opt) && (opt = {
			success: opt
		});
		
		u_.isObject(opt) || (opt = {});
		opt = { methodName: "aRequestExec", ...opt };
		
		return this.aRequest(this.execModeValues.exec, opt);
	}
};
